<template>
  <v-snackbar v-model="isVisible" :timeout="-1" color="info" location="top">
    A new version of the application is available.
    <template v-slot:actions>
      <v-btn variant="text" @click="reloadPage">Reload</v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";

const isVisible = ref(false);
const VERSION_CHECK_INTERVAL = 5 * 60 * 1000;
let intervalId = null;
let initialBuildDate = null;
const DISABLED = !!import.meta.env.VITE_DISABLE_VERSION_CHECK;

async function fetchVersion() {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-cache",
    });
    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.error("Failed to fetch version info:", error);
  }
  return null;
}

function showSnackbar() {
  if (!isVisible.value) {
    isVisible.value = true;
  }
}

function reloadPage() {
  window.location.reload();
}

async function checkForUpdates() {
  const versionInfo = await fetchVersion();
  if (!versionInfo) return;
  initialBuildDate = versionInfo.buildDate;

  intervalId = setInterval(async () => {
    if (document.hidden) return;
    const current = await fetchVersion();
    if (current && current.buildDate !== initialBuildDate) {
      showSnackbar();
      intervalId && clearInterval(intervalId);
    }
  }, VERSION_CHECK_INTERVAL);
}

onMounted(() => {
  if (DISABLED) return;
  checkForUpdates();
});

onUnmounted(() => {
  intervalId && clearInterval(intervalId);
});
</script>
